export const PERMISSION_MODAL_TYPES = Object.freeze({
  USER: 'User Permissions',
  PROJECT: 'Project Permissions'
})

export const FILTER_CATEGORY_ORDER = Object.freeze([
  'Individual Profile',
  'Individual Health',
  'Financial Well-Being',
  'Home and Household',
  'Resource Access Barriers and Support',
  'Community Support and Location',
  'Environmental Exposure'
])

export const USE_CASE_CATEGORY_ORDER = Object.freeze([
  'Public Health',
  'Oncology Care Scenario',
  'Behavioral Health',
  'Health and Human Services'
])

export const FLAG_PERMISSION_SECTIONS = Object.freeze([
  {title: 'Behavioral Personas', field: 'PERSONA_FLAG'},
  {title: 'Trend Analysis', field: 'TREND_ANALYSIS_FLAG'},
  {title: 'Export', field: 'EXPORT_FLAG'},
  {title: 'HealthPrism Agent', field: 'CHATBOT_FLAG'}
])

export const PERMISSION_FIELDS = Object.freeze({
  SUPER_ADMIN: 'SUPER_ADMIN',
  DELIVERY_ADMIN: 'DELIVERY_ADMIN',
  JURISDICTION: 'JURISDICTION',
  FILTERS: 'FILTERS',
  DATA_AGGREGATION: 'DATA_AGGREGATION',
  TREND_ANALYSIS_FLAG: 'TREND_ANALYSIS_FLAG',
  EXPORT_FLAG: 'EXPORT_FLAG',
  CHATBOT_FLAG: 'CHATBOT_FLAG',
  BENEFITS: 'BENEFITS',
  POINT_OF_INTEREST: 'POINT_OF_INTEREST',
  USECASE: 'USECASE',
  PERSONA_FLAG: 'PERSONA_FLAG',
  CHATBOT_EXPORT_FLAG: 'CHATBOT_EXPORT_FLAG',
  CHATBOT_COPY_FLAG: 'CHATBOT_COPY_FLAG'
})

export const PERMISSION_ID_MAP = Object.freeze({
  1: PERMISSION_FIELDS.SUPER_ADMIN,
  2: PERMISSION_FIELDS.DELIVERY_ADMIN,
  3: PERMISSION_FIELDS.JURISDICTION,
  5: PERMISSION_FIELDS.FILTERS,
  6: PERMISSION_FIELDS.DATA_AGGREGATION,
  7: PERMISSION_FIELDS.TREND_ANALYSIS_FLAG,
  8: PERMISSION_FIELDS.EXPORT_FLAG,
  9: PERMISSION_FIELDS.CHATBOT_FLAG,
  10: PERMISSION_FIELDS.BENEFITS,
  12: PERMISSION_FIELDS.POINT_OF_INTEREST,
  13: PERMISSION_FIELDS.USECASE,
  14: PERMISSION_FIELDS.PERSONA_FLAG,
  15: PERMISSION_FIELDS.CHATBOT_EXPORT_FLAG,
  16: PERMISSION_FIELDS.CHATBOT_COPY_FLAG
})
